module.exports = __webpack_public_path__ + "img/mastercard.55c42d54.svg";